import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/findAllForReportTypeView`;

export const ROUTE: RouteDefinition = `${baseRoute}/findAllForReportTypeView`;

export const URL = (): RouteDefinition => `${baseRoute}/findAllForReportTypeView`;
